// UserCategoriesCategory.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import { EMPTY_ARRAY } from '../resource/defaults.js';
import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import UniversalComponent from '../component/UniversalComponent.jsx';
import { createCategoryLoader } from '../resource/createCategoryLoader.js';
import useSSRDataMerge from '../hook/useSSRDataMerge.js';

export const loader = createCategoryLoader({
  pathPrefix: 'user-categories',
  categoryType: 'creators',
  loaderName: 'UserCategoriesCategory',
});

const UserCategoriesCategoryRoute = () => {
  const { data, error, meta = EMPTY_ARRAY } = useLoaderData();

  useSSRDataMerge({
    componentName: 'UserCategoriesCategory',
    loaderData: data,
    loaderError: error,
  });

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <UniversalComponent
        filename="Container_UserMore"
        importer={/* #__LOADABLE__ */ () => import('../container/UserMore.js')}
      />
    </>
  );
};

export default UserCategoriesCategoryRoute;
